/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCubeUnfolded = createReactComponent("cube-unfolded", "IconCubeUnfolded", [
  ["path", { d: "M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z", key: "svg-0" }],
  ["path", { d: "M7 15v-5h5v5h5v-5", key: "svg-1" }]
]);

export { IconCubeUnfolded as default };
//# sourceMappingURL=IconCubeUnfolded.js.map
